<div class="footer">
  <footer class="container mt-5">
    <!-- <p class="float-right"><a href="#">Tillbaka till toppen</a></p> -->
    <p>&copy; {{currentDate | date:'yyyy'}} Powered by <a target="_blank">Parkifly AB, Org.nr: 559454-6698, Wallingatan
        42,
        111 24 Stockholm, Sweden</a>
      &middot; <a [routerLink]="['/terms-and-conditions']">Terms</a>
  </footer>
</div>